import { t } from "@lingui/macro";
import { useSetAtom } from "jotai";

import { ReloadIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { enterMovePlayersBetweenGroupsStepAtom } from "../../../../../../../../../atoms/actions/enterMovePlayersBetweenGroupsStepAtom/enterMovePlayersBetweenGroupsStepAtom";

type Props = {
  roundId: string;
  closeMenu: () => void;
};

export const MovePlayersBetweenGroupsMenuItem = ({
  roundId,
  closeMenu,
}: Props) => {
  const enterMoveStep = useSetAtom(enterMovePlayersBetweenGroupsStepAtom);

  return (
    <Pressable
      testID="move-player-between-groups-menu-item"
      onPress={() => {
        enterMoveStep({ roundId });
        closeMenu();
      }}
    >
      <HStack gap={3} paddingHorizontal={4} paddingVertical={3}>
        <ReloadIcon />
        <Text>{t`Move to another group`}</Text>
      </HStack>
    </Pressable>
  );
};
